import React from "react";

const WhatsAppLogo = ({ size = 24 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="6" fill="#25D366" />
    <path
      d="M12 4.5C7.86 4.5 4.5 7.86 4.5 12c0 1.34.35 2.6.96 3.7L4.5 19.5l3.93-.94A7.46 7.46 0 0012 19.5c4.14 0 7.5-3.36 7.5-7.5S16.14 4.5 12 4.5zm3.47 10.27c-.15.43-.88.82-1.21.87-.3.04-.68.06-1.1-.07-.25-.08-.58-.19-.99-.38-1.74-.75-2.88-2.5-2.97-2.62-.09-.12-.72-.96-.72-1.83 0-.87.46-1.3.62-1.47.16-.18.35-.22.47-.22l.34.01c.11 0 .25-.04.4.3.15.35.5 1.22.55 1.31.04.09.07.2.01.32-.06.12-.09.19-.18.3-.09.1-.19.23-.27.31-.09.09-.18.18-.08.36.1.18.46.75.98 1.21.67.6 1.24.79 1.42.88.18.09.28.07.38-.04.1-.12.44-.51.55-.69.12-.18.23-.15.39-.09.16.06 1.02.48 1.2.57.17.09.29.13.33.2.04.08.04.44-.11.87z"
      fill="#fff"
    />
  </svg>
);

export const WhatsAppCommunityCard = ({ className = "" }) => (
  <div
    className={`bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl p-4 hover:shadow-lg transition-all duration-300 ${className}`}
  >
    <div className="flex items-center space-x-3">
      <div style={{ flexShrink: 0 }}>
        <WhatsAppLogo size={48} />
      </div>
      <div className="flex-1">
        <div className="font-bold text-gray-800 mb-1">Join Mahalaxmi Puja</div>
        <div className="text-sm text-gray-600 mb-2">
          Get daily blessings, puja updates & spiritual guidance
        </div>
        <a
          href="https://chat.whatsapp.com/FYhRGAKRuLW8lxqkAY9Qb6"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-green-600 hover:text-green-700 font-medium text-sm transition-colors"
        >
          Join WhatsApp Community
          <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
);

export const WhatsAppCommunityPill = ({ className = "" }) => (
  <div
    className={`bg-green-500 text-white rounded-full px-6 py-3 shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform duration-300 mx-auto ${className}`}
  >
    <a
      href="https://chat.whatsapp.com/FYhRGAKRuLW8lxqkAY9Qb6"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center justify-center space-x-3 text-white hover:text-white"
    >
      <WhatsAppLogo size={28} />
      <div className="text-center">
        <div className="font-semibold text-sm">Join WhatsApp Community</div>
        <div className="text-xs opacity-90">Blessings • Daily Updates</div>
      </div>
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
        <path
          fillRule="evenodd"
          d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </a>
  </div>
);
